export default __webpack_public_path__ + "static/media/img-board.4d84ae60.jpg";